import actions from "./actions";

const {
  // Awaiting Approval List
  AWAITING_APPROVAL_LIST_BEGIN,
  AWAITING_APPROVAL_LIST_SUCCESS,
  AWAITING_APPROVAL_LIST_ERR,
  AWAITING_APPROVAL_LIST_RESET,

  // Approved Unused List
  APPROVED_UNUSED_LIST_BEGIN,
  APPROVED_UNUSED_LIST_SUCCESS,
  APPROVED_UNUSED_LIST_ERR,
  APPROVED_UNUSED_LIST_RESET,

  // Approved Used List
  APPROVED_USED_LIST_BEGIN,
  APPROVED_USED_LIST_SUCCESS,
  APPROVED_USED_LIST_ERR,
  APPROVED_USED_LIST_RESET,

  // Approval Details
  APPROVAL_DETAILS_BEGIN,
  APPROVAL_DETAILS_SUCCESS,
  APPROVAL_DETAILS_ERR,
  APPROVAL_DETAILS_RESET,

  // Update Approval Data
  UPDATE_APPROVAL_DATA_BEGIN,
  UPDATE_APPROVAL_DATA_SUCCESS,
  UPDATE_APPROVAL_DATA_ERR,
  UPDATE_APPROVAL_DATA_RESET,

  // Check Discount
  CHECK_DISCOUNT_BEGIN,
  CHECK_DISCOUNT_SUCCESS,
  CHECK_DISCOUNT_ERR,
  CHECK_DISCOUNT_RESET,

  // Check Exception Discount
  CHECK_EXCEPTION_DISCOUNT_BEGIN,
  CHECK_EXCEPTION_DISCOUNT_SUCCESS,
  CHECK_EXCEPTION_DISCOUNT_ERR,
  CHECK_EXCEPTION_DISCOUNT_RESET,

  // Submit Exception Discount
  SUBMIT_EXCEPTION_DISCOUNT_BEGIN,
  SUBMIT_EXCEPTION_DISCOUNT_SUCCESS,
  SUBMIT_EXCEPTION_DISCOUNT_ERR,
  SUBMIT_EXCEPTION_DISCOUNT_RESET,
} = actions;

const initialState = { data: null, loading: false, error: null };

export const awaitingApprovalReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case AWAITING_APPROVAL_LIST_BEGIN:
      return { ...initialState, loading: true };
    case AWAITING_APPROVAL_LIST_SUCCESS:
      return { ...initialState, data: data };
    case AWAITING_APPROVAL_LIST_ERR:
      return { ...initialState, error: err };
    case AWAITING_APPROVAL_LIST_RESET:
      return initialState;
    default:
      return state;
  }
};

export const approvedUnusedReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case APPROVED_UNUSED_LIST_BEGIN:
      return { ...initialState, loading: true };
    case APPROVED_UNUSED_LIST_SUCCESS:
      return { ...initialState, data: data };
    case APPROVED_UNUSED_LIST_ERR:
      return { ...initialState, error: err };
    case APPROVED_UNUSED_LIST_RESET:
      return initialState;
    default:
      return state;
  }
};

export const approvedUsedReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case APPROVED_USED_LIST_BEGIN:
      return { ...initialState, loading: true };
    case APPROVED_USED_LIST_SUCCESS:
      return { ...initialState, data: data };
    case APPROVED_USED_LIST_ERR:
      return { ...initialState, error: err };
    case APPROVED_USED_LIST_RESET:
      return initialState;
    default:
      return state;
  }
};

export const managerApprovalDetailsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case APPROVAL_DETAILS_BEGIN:
      return { ...initialState, loading: true };
    case APPROVAL_DETAILS_SUCCESS:
      return { ...initialState, data: data };
    case APPROVAL_DETAILS_ERR:
      return { ...initialState, error: err };
    case APPROVAL_DETAILS_RESET:
      return initialState;
    default:
      return state;
  }
};

export const updateApprovalDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case UPDATE_APPROVAL_DATA_BEGIN:
      return { ...initialState, loading: true };
    case UPDATE_APPROVAL_DATA_SUCCESS:
      return { ...initialState, data: data };
    case UPDATE_APPROVAL_DATA_ERR:
      return { ...initialState, error: err };
    case UPDATE_APPROVAL_DATA_RESET:
      return initialState;
    default:
      return state;
  }
};

export const checkDiscountReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CHECK_DISCOUNT_BEGIN:
      return { ...initialState, loading: true };
    case CHECK_DISCOUNT_SUCCESS:
      return { ...initialState, data };
    case CHECK_DISCOUNT_ERR:
      return { ...initialState, error: err };
    case CHECK_DISCOUNT_RESET:
      return initialState;
    default:
      return state;
  }
};

export const checkExceptionDiscountReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CHECK_EXCEPTION_DISCOUNT_BEGIN:
      return { ...initialState, loading: true };
    case CHECK_EXCEPTION_DISCOUNT_SUCCESS:
      return { ...initialState, data };
    case CHECK_EXCEPTION_DISCOUNT_ERR:
      return { ...initialState, error: err };
    case CHECK_EXCEPTION_DISCOUNT_RESET:
      return initialState;
    default:
      return state;
  }
};

export const submitExceptionDiscountReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SUBMIT_EXCEPTION_DISCOUNT_BEGIN:
      return { ...initialState, loading: true };
    case SUBMIT_EXCEPTION_DISCOUNT_SUCCESS:
      return { ...initialState, data };
    case SUBMIT_EXCEPTION_DISCOUNT_ERR:
      return { ...initialState, error: err };
    case SUBMIT_EXCEPTION_DISCOUNT_RESET:
      return initialState;
    default:
      return state;
  }
};
